import { Component, Inject } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface LinkedTableAddDialogInput {
  title: string
  placeholder: string
  /** Set to also ask for a free-text description; the field is hidden when omitted. */
  descriptionPlaceholder?: string
}
export interface LinkedTableAddDialogOutput {
  name: string
  description: string | null
}

@Component({
  selector: 'app-linked-table-add-dialog',
  templateUrl: './linked-table-add-dialog.component.html',
  styleUrls: ['./linked-table-add-dialog.component.scss']
})
export class LinkedTableAddDialogComponent {
  form = new FormGroup({
    name: new FormControl<string>(null, [Validators.required]),
    description: new FormControl<string>(null)
  })

  constructor(
    public dialogRef: MatDialogRef<LinkedTableAddDialogComponent, LinkedTableAddDialogOutput|undefined>,
    @Inject(MAT_DIALOG_DATA) public data: LinkedTableAddDialogInput
  ) {}

  onClose() {
    this.dialogRef.close()
  }

  onSubmit() {
    const controls = this.form.controls
    if (this.form.invalid) {
      Object.keys(controls).forEach(controlName => {
        controls[controlName].markAsTouched()
      })
      return;
    }

    const description = controls.description.value ? controls.description.value.trim() : null
    this.dialogRef.close({
      name: controls.name.value.trim(),
      description: description ? description : null
    })
  }
}
